<template>
  <div>
    <store-video-sample-menu v-if="categoryPage"
      :options="options"
      :hasThumbnail="hasThumbnail"
      :disablePlaycountApi="disablePlaycountApi"
    ></store-video-sample-menu>
    <div v-if="ordermade">
      <p class="ordermade-sample-heading">オーダーメイド型占い</p>
      <div class="ordermade-sample-title">
        <span>占い師があたなだけのために占った動画をお届けします。 オプション（有料）で占い師の指名も可能です。 <br>※完全オーダーメイド式のためお届けまで7日間程かかります。</span>
      </div>
      <p class="ordermade-sample-message section_title u-tx-center u-mg-b-2">こんな動画が届きます！</p>
      <store-video-player
        class="ordermade-sample-video"
        :options="options"
        :hasThumbnail="hasThumbnail"
        :disablePlaycountApi="disablePlaycountApi"
      ></store-video-player>
    </div>
    <category-uranai-items
      :categoryName="categoryName"
      :items="categoryItems"
    ></category-uranai-items>
    <div v-if="ordermade">
      <div class="modernBox shape">
        <div class="modernBox__description">
          <span>お届けまでの流れ</span>
        </div>
        <div class="modernBox__contents">
          <div class="videoletter_steps">
            <div class="content u-mg-t-4">

              <div class="step">
                <p class="step_number">1</p>
                <div class="step_textarea u-mg-b-1 u-mg-t-1">
                  <p class="title">申し込み受付</p>
                  <p class="u-mg-t-1 step_desc"><span class="wordbreak">占いに必要な情報を</span><span class="wordbreak">入力し、料金を</span><span class="wordbreak">お支払いください</span></p>
                </div>
              </div>

              <div class="step">
                <p class="step_number">2</p>
                <div class="step_textarea u-mg-b-1 u-mg-t-1">
                  <p class="title">占い＆撮影</p>
                  <p class="u-mg-t-1 step_desc"><span class="wordbreak">占い師があなた</span><span class="wordbreak">専用の占い動画を</span><span class="wordbreak">撮影します</span></p>
                </div>
              </div>

              <div class="step">
                <p class="step_number">3</p>
                <div class="step_textarea u-mg-b-1 u-mg-t-1">
                  <p class="title">動画をお届け</p>
                  <p class="u-mg-t-1 step_desc"><span class="wordbreak">視聴用のURLを</span><span class="wordbreak">メールで</span><span class="wordbreak">お届けします！</span></p>
                </div>
              </div>

              <p class="step_sub">※お支払い完了日より、3日〜2週間でお届けします</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryUranaiItems from './CategoryUranaiItems'
import StoreVideoPlayer from './StoreVideoPlayer'
import StoreVideoSampleMenu from './StoreVideoSampleMenu'


export default {
  name: 'category-uranai-list',
  props: {
    category: {
      type: String,
      default: null
    },
    categoryName: {
      type: String,
      default: null
    },
    categoryItems: {
      type: Array,
      default: () => ([])
    },
    options: {
      type: Object,
      default: () => ({})
    },
    hasThumbnail: { type: Boolean, default: false },
    disablePlaycountApi: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ordermade() {
      if(this.category == 'ordermade') {
        return true
      } else {
        return false
      }
    },
    categoryPage() {
      if(this.category == 'ordermade') {
        return false
      } else {
        return true
      }
    }
  },
  components: {
    CategoryUranaiItems,
    StoreVideoPlayer,
    StoreVideoSampleMenu
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables/colors.scss';
@import '../../../sass/functions/breakpoint.scss';

.ordermade-sample-heading {
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  color: $brand-0;
  padding: 20px 12px 0;
  border-top: 1px solid #ededed;
}

.ordermade-sample-title {
  font-size: 12px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
  line-height: 18px;
  margin: 20px 12px 0;
}

.ordermade-sample-message {
  margin-top: 24px;
  color: #ed1E79;
  font-weight: bold;
  font-size: 16px;
}

.ordermade-sample-video {
  margin: 0 auto;
  width: 46.4vw;
  @media screen and (min-width: 768px) {
    max-width: 14vw;
  }
}

.content {
  padding-bottom: 16px;
}

.step_desc {
  font-size: 11px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}

.step_sub {
  font-size: 10px;
  padding: 0 0 16px 8px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}

.modernBox {
  width: 100%;
  background: white;
  &__header {
    padding: 16px 12px;
    font-size: 12px;
  }
  &__introduction {
    background: $gray-12;
    padding: 16px 12px;
  }
  &__title {
    color: $brand-2;
    background: $white;
    font-size: 16px;
    font-weight: bold;
    line-height: 14px;
    text-align: center;
    padding: 18px;
    border-radius: 5px 5px 0 0;
  }
  &__contents {
    display: inline-block;
    width: 100%;
  }
  &__description {
    border-top: 1px solid #eeeeee;
    font-family: 'a-otf-gothic-bbb-pr6n', sans-serif;
    color: #000000;
    font-size: 15px;
    line-height: 15px;
    margin: 61px 8px 0;
    text-align: center;
    padding: 40px 0 0;
    border-top: 1px solid #EDEDED;
  }
  &__bottom {
    background: white;
    border-top: 1px solid #eeeeee;
    height: 40px;
    margin: 0 16px;
  }
  &__illust {
    background: $white;
    padding: 0 12px 8px 12px;
    img {
      width: 100%;
    }
  }
  &__detail {
    color: $white;
    background: $brand-2;
    font-size: 16px;
    font-weight: bold;
    line-height: 14px;
    text-align: center;
    padding: 9px;
    border-radius: 0 0 4px 4px;
  }
  &.shape {
    margin-top: -10px;
    border-top: hidden;
    padding-bottom: 30px;
  }
  .listGroup__body {
    ul {
      padding: 0 8px;
      li {
        &:last-child {
          border-bottom: 1px solid $gray-6;
        }
      }
    }
  }
}


</style>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/CategoryUranaiList.vue